import { render, staticRenderFns } from "./ScoreLeaderboardContent.vue?vue&type=template&id=989c5602&scoped=true&"
import script from "./ScoreLeaderboardContent.vue?vue&type=script&lang=js&"
export * from "./ScoreLeaderboardContent.vue?vue&type=script&lang=js&"
import style0 from "./ScoreLeaderboardContent.vue?vue&type=style&index=0&id=989c5602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989c5602",
  null
  
)

export default component.exports